import React from "react"

import * as S from "./styled"

const Home = ({ children }) => <S.Home> {children} </S.Home>

export default Home
